import React, { useMemo, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
} from '@coreui/react'
 import explorerLogo from "../assets/icons/explorer_logo.png";
import explorerName from "../assets/icons/explorer_name.png";
import CIcon from '@coreui/icons-react'

// sidebar nav config
import navigation from './_nav'

const TheSidebar = () => {
  const dispatch = useDispatch()
  const show = useSelector(state => state.sidebarShow)
  
  // Normalize the show value to ensure it matches expected prop types
  const normalizeShow = (value) => {
    const validValues = ["", true, false, "responsive"];
    if (validValues.includes(value)) {
      return value;
    }
    // Convert string 'false' to boolean false for backwards compatibility
    if (value === 'false') {
      return false;
    }
    // Convert string 'true' to boolean true for backwards compatibility  
    if (value === 'true') {
      return true;
    }
    // Default to false if value is not recognized
    return false;
  }
  
  const normalizedShow = normalizeShow(show)
  const names = useSelector(state => state.count)
  const [token, setToken] = useState(sessionStorage.getItem("login") ?? null);
  
  useEffect(() => {
    const handleStorageChange = () => {
      setToken(sessionStorage.getItem("login") ?? null);
    };
    
    window.addEventListener('storage', handleStorageChange);
    const interval = setInterval(() => {
      const currentToken = sessionStorage.getItem("login") ?? null;
      if (currentToken !== token) {
        setToken(currentToken);
      }
    }, 1000);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [token]);

  const navItems = useMemo(() => {
    return navigation
      .filter(item => {
        // Filter out items that require authentication if token is not present
        if (item.requiresAuth && !token) {
          return false;
        }
        return true;
      })
      .map(item => {
        // Remove the requiresAuth prop to prevent it from reaching DOM elements
        const { requiresAuth, ...cleanItem } = item;
        return cleanItem;
      });
  }, [token]);

  return (
    <CSidebar
      show={normalizedShow}
      onShowChange={(val) => {
        // Ensure val is one of the expected values
        const validValues = ["", true, false, "responsive"];
        const normalizedVal = validValues.includes(val) ? val : false;
        dispatch({type: 'set', sidebarShow: normalizedVal });
      }}
    >
      <CSidebarBrand className="d-md-down-none" to="/">
        <CIcon
          className="c-sidebar-brand-full"
          // name="logo-negative"
          src={explorerLogo}
          height={35}
        />
        <CIcon
          className="c-sidebar-brand-full"
          style={{ marginLeft: '10px' }}
          // name="logo-negative"
          src={explorerName}
          height={35}
        />
        <CIcon
          className="c-sidebar-brand-minimized"
          src={explorerLogo}
          height={35}
        />
      </CSidebarBrand>
      <CSidebarNav>
      <p  className="c-sidebar-brand-full"><strong style={{margin: '50px'}}>{names || sessionStorage.getItem("userDid")}</strong></p>
    
        <CCreateElement
          items={navItems}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none"/>
    </CSidebar>
  )
}

export default React.memo(TheSidebar)
